/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Tut_Sc_NextInputs */

const en_pc_tut_sc_next = /** @type {(inputs: Pc_Tut_Sc_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next search match`)
};

const zh_pc_tut_sc_next = /** @type {(inputs: Pc_Tut_Sc_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下一个搜索结果`)
};

/**
* | output |
* | --- |
* | "Next search match" |
*
* @param {Pc_Tut_Sc_NextInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_tut_sc_next = /** @type {((inputs?: Pc_Tut_Sc_NextInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Tut_Sc_NextInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_tut_sc_next(inputs)
	return zh_pc_tut_sc_next(inputs)
});
export { pc_tut_sc_next as "pc.tut.sc.next" }